export default __webpack_public_path__ + "static/media/settings.12d4907e.svg";